<template>
    <transition-root :show="true" as="template">
        <dialog-headless
            as="div"
            class="fixed z-10 inset-0 overflow-y-auto"
            @close="closeModal()"
        >
            <div
                class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0"
            >
                <transition-child
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0"
                    enter-to="opacity-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100"
                    leave-to="opacity-0"
                >
                    <dialog-overlay
                        class="fixed inset-0 bg-gray-600/75 transition-opacity"
                    />
                </transition-child>

                <span
                    class="hidden sm:inline-block sm:align-middle sm:h-screen"
                    aria-hidden="true"
                    >&#8203;</span
                >
                <transition-child
                    as="template"
                    enter="ease-out duration-300"
                    enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to="opacity-100 translate-y-0 sm:scale-100"
                    leave="ease-in duration-200"
                    leave-from="opacity-100 translate-y-0 sm:scale-100"
                    leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        class="relative z-10 inline-block align-bottom bg-gray-700 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6"
                    >
                        <form @submit.prevent="blockCashout()">
                            <div class="sm:flex sm:items-start">
                                <div
                                    class="mx-auto shrink-0 flex items-center justify-center h-12 w-12 sm:mx-0 sm:h-10 sm:w-10"
                                >
                                    <font-awesome-icon
                                        icon="fa-solid fa-money-bill-transfer"
                                        class="mx-auto mt-1 w-10 h-10 text-red-400"
                                        aria-hidden="true"
                                    />
                                </div>
                                <div
                                    class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left"
                                >
                                    <dialog-title
                                        as="h3"
                                        class="text-lg leading-6 font-medium text-white"
                                    >
                                        Bloquear Saque
                                    </dialog-title>
                                    <div class="mt-2">
                                        <div class="text-md text-white">
                                            Você tem certeza que deseja bloquear os saques para
                                            <p class="text-bold text-red-400">
                                                {{ user?.name }} ({{ user?.email }}) ?
                                            </p>
                                            <p class="mt-2 text-gray-300 text-sm">
                                                Após o bloqueio, o usuário não poderá mais sacar enquanto
                                                seus produtos estiverem com status diferente de "aprovado".
                                            </p>
                                        </div>

                                        <div class="my-3">
                                            <label
                                                for="reason-input"
                                                class="block mb-2 text-sm font-medium text-gray-300"
                                            >
                                                Motivo (obrigatório)
                                            </label>
                                            <textarea
                                                v-model="reason"
                                                id="reason-input"
                                                rows="3"
                                                class="block p-4 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 sm:text-md focus:ring-red-500 focus:border-red-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-red-500 dark:focus:border-red-500"
                                                placeholder="Descreva o motivo do bloqueio (mínimo 10 caracteres)..."
                                            ></textarea>
                                            <p v-if="error" class="text-red-500 text-sm mt-1">{{ error }}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse"
                            >
                                <button
                                    type="submit"
                                    :disabled="loading"
                                    class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm disabled:opacity-50"
                                >
                                    {{ loading ? 'Bloqueando...' : 'Confirmar Bloqueio' }}
                                </button>

                                <button
                                    type="button"
                                    class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:w-auto sm:text-sm"
                                    @click="closeModal()"
                                    ref="cancelButtonRef"
                                >
                                    Cancelar
                                </button>
                            </div>
                        </form>
                    </div>
                </transition-child>
            </div>
        </dialog-headless>
    </transition-root>
</template>

<script>
import {
    Dialog,
    DialogOverlay,
    DialogTitle,
    TransitionChild,
    TransitionRoot,
} from "@headlessui/vue";
import { mapWritableState } from "pinia";
import { Store } from "../../../stores/store";
import { useToast } from "vue-toastification";

export default {
    components: {
        DialogHeadless: Dialog,
        DialogOverlay,
        DialogTitle,
        TransitionChild,
        TransitionRoot,
    },
    data() {
        return {
            reason: "",
            error: "",
            loading: false,
        };
    },
    setup() {
        const toast = useToast();
        return { toast };
    },
    computed: {
        ...mapWritableState(Store, ["user"]),
    },
    methods: {
        closeModal() {
            this.reason = "";
            this.error = "";
            this.$emit("closeModal");
        },
        blockCashout() {
            if (this.reason.length < 10) {
                this.error = "O motivo deve ter no mínimo 10 caracteres.";
                return;
            }

            this.loading = true;
            this.error = "";

            axios
                .post(`/api/financial/cashout-release/revoke`, {
                    user_id: this.user?.id,
                    reason: this.reason,
                })
                .then(({ data }) => {
                    this.toast.success(data?.message || "Saque bloqueado com sucesso!");
                    this.$emit("closeModalAndFetch");
                })
                .catch(({ response }) => {
                    const message = response?.data?.message || "Erro ao bloquear saque.";
                    this.error = message;
                    this.toast.error(message);
                })
                .finally(() => {
                    this.loading = false;
                });
        },
    },
};
</script>
